// extracted by mini-css-extract-plugin
module.exports = {"title":"MantineModal_title__DQPKj","header":"MantineModal_header__zfBTR"};